/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IUor } from "../shared/interfaces";

const controller = 'Teams';



const createChannel = (channelName, cancelToken?: CancelToken): Promise<IUor[]> => {
    return axiosInstance.get(`${controller}/CreateChannel/${channelName}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



export default {
    createChannel
}